module.exports = __webpack_public_path__ + "static/media/FotosCentro12.5ade63ef.jpg";